'use client';

import { useId } from 'react';

import { FilterSection } from './filter-section.component';

import { Checkbox } from '@/components/ui/checkbox/checkbox.component';

export interface FilterCheckboxOption<TKey extends string> {
  key: TKey;
  label: string;
}

interface FilterCheckboxGroupSectionProps<TKey extends string> {
  label: string;
  options: readonly FilterCheckboxOption<TKey>[];
  values: Readonly<Record<TKey, boolean>>;
  onChange: (key: TKey, checked: boolean) => void;
  testId?: string;
  getOptionTestId?: (key: TKey) => string;
}

export function FilterCheckboxGroupSection<TKey extends string>({
  label,
  options,
  values,
  onChange,
  testId,
  getOptionTestId,
}: FilterCheckboxGroupSectionProps<TKey>) {
  const labelId = useId();

  return (
    <FilterSection label={label} labelId={labelId}>
      <div role="group" aria-labelledby={labelId} className="flex flex-col gap-2" data-testid={testId}>
        {options.map((option) => (
          <Checkbox
            key={option.key}
            container="box"
            checked={values[option.key]}
            onCheckedChange={(checked) => onChange(option.key, checked === true)}
            data-testid={getOptionTestId?.(option.key)}
          >
            {option.label}
          </Checkbox>
        ))}
      </div>
    </FilterSection>
  );
}
